import OverviewSection from "./sections/OverviewSection";
import OnboardingSection from "./sections/OnboardingSection";
import VideoSection from "./sections/VideoSection";
import IntelligenceSection from "./sections/IntelligenceSection";

export default function ExperiencePage() {
  return (
    <div>
      <OverviewSection />
      <OnboardingSection />
      <VideoSection />
      <IntelligenceSection />
    </div>
  );
}
